import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ConversationalSettingsForNRO = lazy(() =>
  import("@scenes/ConversationalSettings").then((module) => ({
    default: module.ConversationalSettings,
  }))
);

export const conversationalSettingsNRO: NavigationRoutingObject = {
  Component: ConversationalSettingsForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("conversational-settings-nro-heading", "Global Conversational Settings"),
  pageNameForTracking: () => "Global Conversational Settings",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("agent_console_conversational");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
